import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { CampaignStepEntity } from './CampaignStepEntity'
import type { CampaignTranslationEntity } from './CampaignTranslationEntity'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { CampaignRegionsEntity } from './CampaignRegionsEntity'
import type { UserGroupMiniEntity } from '@/features/userGroup/domain/entities/UserGroupMiniEntity'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { ServiceMiniEntity } from '@/features/service/domain/entities/ServiceMiniEntity'

export class CreateCampaignEntity {
  startDate?: string
  endDate?: string
  priority?: number | null
  isActive?: boolean
  steps?: Array<CampaignStepEntity> | null
  users?: Array<UserMiniEntity> | null
  includeBranches?: Array<BranchMiniEntity> | null
  excludeBranches?: Array<BranchMiniEntity> | null
  groups?: Array<UserGroupMiniEntity> | null
  channels?: Array<ChannelMiniEntity> | null
  regions?: Array<CampaignRegionsEntity> | null
  translations?: Array<CampaignTranslationEntity> | null
  services?: Array<ServiceMiniEntity> | null
  atNumberOfOrders?: Array<number> | null
  maxUsage?: number | null
  maxUserUsage?: number | null
}
